import { ComponentType } from '@angular/cdk/portal';
import {
  Component,
  ComponentRef,
  Inject,
  Injector,
  ModuleWithProviders,
  OnInit,
  ViewChild,
  ɵcreateInjector as createInjector,
  ChangeDetectionStrategy
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialogComponent } from './models/base/base-dialog.component';
import { DialogContentHostDirective } from './dialog-content-host.directive';
import { __ } from '../../functions/object.functions';

export class DialogData<TModule, TComponent, TData> {
  getModule?: () => Promise<ModuleWithProviders<TModule>>;
  getComponent?: () => Promise<ComponentType<TComponent>>;
  componentData?: TData;
  title?: string;
  text?: string;
  contentMaxHeight?: string;
}

@Component({
    selector: 'intello-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogComponent<TModule, TComponent, TData> extends BaseDialogComponent implements OnInit {

  mode: 'Component' | 'Text';

  @ViewChild(DialogContentHostDirective, { static: true }) contentDialogHost: DialogContentHostDirective;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData<TModule, TComponent, TData>,
    public dialogRef: MatDialogRef<DialogComponent<TModule, TComponent, TData>>,
    private injector: Injector
  ) {
    super();
  }

  ngOnInit() {
    if (!__.IsNullOrUndefined(this.data.getModule) && !__.IsNullOrUndefined(this.data.getComponent)) {
      this.mode = 'Component';

      const viewContainerRef = this.contentDialogHost.viewContainerRef;
      viewContainerRef.clear();

      this.data.getModule().then((module: ModuleWithProviders<TModule>) => {
        const injector = createInjector(module, this.injector);

        this.data.getComponent().then((component: ComponentType<TComponent>) => {
          const createdComponent = this.contentDialogHost.viewContainerRef.createComponent(component, { injector });

          if (!__.IsNullOrUndefined(this.data.componentData)) {
            Object.assign(createdComponent.instance, this.data.componentData);
          }
        });
      });
    } else if (!__.IsNullOrUndefinedOrEmpty(this.data.text) && !__.IsNullOrUndefinedOrEmpty(this.data.title)) {
      this.mode = 'Text';
    }
  }
}
